import IconAnimatedSpinner from 'assets/icons/animated-spinner.svg';
import { SentryProvider } from 'contexts/sentry';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useIntl } from 'react-intl';
import robots from '../../../components/seo/robots';
import title from '../../../components/seo/title';

const CartAsync = dynamic(() => import('modules/cart'), {
  loading: () => <IconAnimatedSpinner className="text-text-dark-bg-contrast-white h-6 w-6" />,
  ssr: false,
});

const SubscriptionReminderProviderAsync = dynamic(
  () => import('../../../contexts/subscription-reminder'),
  {
    loading: () => <IconAnimatedSpinner className="text-text-dark-bg-contrast-white h-6 w-6" />,
    ssr: false,
  }
);

const CartPage: NextPage = () => {
  const intl = useIntl();

  return (
    <>
      <Head>
        {title(intl.formatMessage({ id: 'cart:title' }))}
        {robots('noindex, follow')}
      </Head>
      <SentryProvider pageName={'cart'}>
        <SubscriptionReminderProviderAsync>
          <CartAsync />
        </SubscriptionReminderProviderAsync>
      </SentryProvider>
    </>
  );
};

export default CartPage;
